<template>
  <div class="main-pcSalidasProduccion">
    <div>
      <!-- Salidas produccion Filter -->
      <div class="content-filter-fixed">
        <div class="content-filter  padding">
          <f7-list>
            <div class="margin-bottom-half">
              {{ $t('production.dump.outputSearch.popup.elementType.label') }}
            </div>
            <f7-list-input
              type="select"
              :placeholder="$t('production.dump.outputSearch.popup.elementType.placeholder')"
              validate
              default-value="1"
              :value="elementSelected"
              @change="EventElementoSelected($event.target.value)"
            >
              <option :value="1">
                {{ $t('production.dump.outputSearch.popup.elementType.options.productionOutput') }}
              </option>
              <option :value="3">
                {{ $t('production.dump.outputSearch.popup.elementType.options.palletizingPoint') }}
              </option>
            </f7-list-input>
          </f7-list>
        </div>
        <div class="content-selection padding-horizontal padding-bottom-half">
          <img
            v-if="allSelec"
            :src="icCheckOn"
            alt="iconCheckOn"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <img
            v-else
            :src="icCheckOff"
            alt="iconCheckOff"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <span class="span-selection padding-horizontal">
            {{ $t('common.select').toUpperCase() }}
          </span>
        </div>
      </div>

      <UCPreload :show="showPreload" />

      <!-- Lineas Pedido Venta Resultados -->
      <f7-list
        media-list
        class="content-salidas-produccion-list"
      >
        <f7-list-item
          v-for="(item, index) in listaFiltros"
          :key="index"
          :title="`${item.ElementoProduccion.Elemento.Codigo} - ${item.ElementoProduccion.Elemento.Nombre}`"
          @click="OrderLineSelection(item)"
        >
          <template #media>
            <div class="margin-top">
              <img
                v-if="item.Seleccionada === true"
                :src="icCheckOn"
                width="18"
                height="18"
              >
              <img
                v-else
                :src="icCheckOff"
                alt="iconCheckOff"
                width="18"
                height="18"
              >
            </div>
          </template>
        </f7-list-item>
      </f7-list>
      <!-- ************* BOTON ************** -->
      <div class="content-lineas-pedido-venta-button padding-half">
        <f7-button
          fill
          color="green"
          @click="EventListaSeleccionada()"
        >
          {{ $t('common.confirm') }}
        </f7-button>
      </div>
    </div>
    <!-- ************* CONFIRMAR ************** -->
  </div>
</template>

<script>
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import icCheckOn from '@/static/icons/ic_checked_on.svg';
import icCheckOff from '@/static/icons/ic_checked_off.svg';
import { HiNotification } from '@/js/common/HINotificationSupport';

import UCPreload from '@/components/common/UCPreload.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCSalidasProduccion',
  components: {
    UCPreload,
  },
  props: {
    punto: {
      type: Object,
      default: undefined,
    },
  },

  emits: ['selected'],

  data() {
    return {
      elementSelected: 1, // elemento del select
      listaFiltros: [], // Lista de los filtros
      showPreload: false,
      icCheckOn,
      icCheckOff,
      allSelec: false,
    };
  },

  mounted() {
    this.StartComponent();
  },
  created() {
    this.StartComponent();
  },

  methods: {
    async StartComponent() {
      Log(this, this.StartComponent.name);
      await this.GetMainData();
      this.EventListaSeleccionada();
    },
    /** @public */
    ClearElementSelected() {
      Log(this, this.ClearElementSelected.name);
      this.OrderLineSelection(null);
    },
    async GetMainData() {
      Log(this, this.GetMainData.name);
      await this.GETDataSalesOrderLine();
    },

    OrderLineSelection(value) {
      Log(this, this.OrderLineSelection.name);

      const selected = value.Seleccionada === true;
      if (selected) {
        this.allSelec = false;
      }

      const filteredItem = this.listaFiltros.find((lpv) => lpv.ElementoProduccion.Elemento.Id === value.ElementoProduccion.Elemento.Id);

      if (filteredItem) {
        filteredItem.Modificado = true;
        filteredItem.Seleccionada = !selected;
      }
    },

    EventListaSeleccionada() {
      Log(this, this.EventListaSeleccionada.name);
      const listaSelected = [];
      const tempLista = this.listaFiltros.filter((s) => s.Modificado === true && s.Seleccionada !== s.EstadoInicial);
      tempLista.forEach((e) => {
        if (e.Seleccionada) {
          e.FechaInicio = new Date();
          e.FechaFin = null;
        } else {
          e.FechaFin = new Date();
        }

        listaSelected.push(e);
      });
      this.GuardarPuntoVolcadoElementoProduccion(listaSelected);
      const selected = [];
      this.listaFiltros.filter((s) => s.Seleccionada).forEach((element) => {
        if (element.Seleccionada) {
          selected.push(element);
        }
      });
      this.$emit('selected', selected);
      f7.popup.close('.busquedaLineas-popup');
      this.GetMainData();
    },
    EventElementoSelected(value) {
      Log(this, this.EventElementoSelected.name);
      this.elementSelected = value;
      this.GetMainData();
    },

    AllSelected() {
      this.listaFiltros.forEach((i) => {
        i.Modificado = true;
      });
      if (this.allSelec) {
        this.allSelec = false;
        this.listaFiltros.forEach((i) => {
          i.Seleccionada = false;
        });
      } else {
        this.allSelec = true;
        this.listaFiltros.forEach((i) => {
          i.Seleccionada = true;
        });
      }
    },

    async GuardarPuntoVolcadoElementoProduccion(lst) {
      Log(this, this.GuardarPuntoVolcadoElementoProduccion.name);
      this.showPreload = true;
      const result = await ConexionTA.callGuardarPuntoVolcadoElementoProduccion(lst);
      if (result.Valor) {
        HiNotification.Toast(this.$t('production.dump.outputSearch.popup.save.successToastText'));
      } else {
        HiNotification.Toast(this.$t('production.dump.outputSearch.popup.save.errorToastText'));
      }
      this.showPreload = false;
    },
    async GETDataSalesOrderLine() {
      Log(this, this.GETDataSalesOrderLine.name);
      this.showPreload = true;
      const result = await ConexionTA.callSalidaProduccionxLineaProduccionPuntoVolcado(this.punto.Id, this.elementSelected);

      this.showPreload = false;
      if (result.Valor) {
        this.listaFiltros = result.Tag;
        this.listaFiltros.forEach((i) => {
          i.Modificado = false;
          if (i.Id !== 0) {
            i.Seleccionada = true;
            i.EstadoInicial = true;
          } else {
            i.Seleccionada = false;
            i.EstadoInicial = false;
          }
        });
      } else {
        HiNotification.Toast(result.Mensaje || this.$t('production.info.couldNotQuerySalesOrderInformation'));
      }
    },
  },
};
</script>

<style lang="scss">
.main-pcSalidasProduccion {
  background-color: var(--his-tierra-white);

  .content-filter-fixed {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 5;
    background-color: var(--his-tierra-white);
    width: 100%;

    .content-filter {
      display: flex;
      justify-content: center;

      > div {
        width: 100%;
      }

      .list li {
        height: 35px;
      }
    }
  }

  .content-filter,
  .content-filter-search {
    --search-input-height: 36px;
    --search-input-color: var(--his-dark-blue);
    --search-font-size: 16px;
    --search-input-padding: 0 8px;
    --search-btn-border-left: 0;

    .content-search-input input {
      &::placeholder {
        font-size: 13px;
        color: #a0a6b7;
      }
    }
  }

  .content-salidas-produccion-list {
    margin-top: 130px;
    height: calc(100vh - 200px - var(--f7-navbar-height));
    overflow-y: scroll;

    @media (min-width: 630px) {
      margin-top: 130px;
      height: calc(var(--f7-popup-tablet-height) - 200px - var(--f7-navbar-height));
    }

    .item-media {
      min-width: 0;
      padding-top: 0;
    }

    .item-title-row {
      align-items: center;

      .item-title {
        color: #172b4d;
        font-size: 14px;
      }

      .item-after {
        height: 24px;
      }
    }

    .item-subtitle {
      color: var(--his-darkgray);
      font-size: 13px;
    }

    .item-text {
      color: var(--his-oliva);
      font-size: 12px;
    }
  }

  .span-selection {
    color: var(--his-darkgray);
    font-size: 14px;
  }

  .content-lineas-pedido-venta-button {
    position: fixed;
    bottom: 0;
    width: calc(100% - 32px);
    border-top: 1px solid #dedfe1;
  }
}
</style>
